// components/DescriptionCell.jsx
import React from "react";

const TextFieldCell = ({ html, maxWidth, onClick }) => {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: html }}
      onClick={onClick}
      style={{
        whiteSpace: "normal",
        wordBreak: "break-word",
        overflowWrap: "break-word",
        lineHeight: "1.5",
        maxWidth: maxWidth || "100%", // fallback if maxWidth is not passed
        cursor: onClick ? "pointer" : undefined,
      }}
    />
  );
};

export default TextFieldCell;
